var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0542 39.5H13.0542M34.0542 39.5C35.9108 39.5 37.6912 40.2375 39.004 41.5503C40.3167 42.863 41.0542 44.6435 41.0542 46.5H6.05424C6.05424 44.6435 6.79174 42.863 8.1045 41.5503C9.41725 40.2375 11.1977 39.5 13.0542 39.5M34.0542 39.5V31.625C34.0542 30.176 32.8806 29 31.4292 29H29.3969M13.0542 39.5V31.625C13.0542 30.176 14.2302 29 15.6792 29H17.7139M29.3969 29H17.7139M29.3969 29C28.0863 26.7366 27.3031 24.2067 27.1056 21.5987M17.7139 29C19.0237 26.7364 19.8061 24.2065 20.0029 21.5987M39.3042 5.634V6.25C39.3042 11.1687 37.0502 15.56 33.5176 18.4487C31.6501 19.978 29.4575 21.0559 27.1056 21.5987M27.1056 21.5987C24.7687 22.1377 22.3398 22.1377 20.0029 21.5987M7.80424 5.634V6.25C7.80424 11.1687 10.0582 15.56 13.5909 18.4487C15.4577 19.9776 17.6518 21.0556 20.0029 21.5987M7.80424 5.634C5.51291 5.96767 3.24491 6.37367 1.00024 6.84733C1.52057 9.90117 3.03859 12.6964 5.31678 14.7955C7.59497 16.8947 10.5048 18.1794 13.5909 18.4487M7.80424 5.634V2.099C12.9516 1.37333 18.2109 1 23.5542 1C28.8999 1 34.1592 1.37333 39.3042 2.09667V5.634M39.3042 5.634C41.5846 5.96581 43.8538 6.37046 46.1082 6.84733C45.588 9.90082 44.0703 12.6957 41.7926 14.7949C39.5149 16.894 36.6033 18.1789 33.5176 18.4487",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrophy);
export default __webpack_public_path__ + "static/media/icon-trophy.46cd2b24ce059f3cd54ca9f13942181f.svg";
export { ForwardRef as ReactComponent };